import React, { useState } from 'react';

const CardDependente = ({
  item,
  abreModalExcluir,
  abreModalSenha,
  abreModalEmail,
  abreModalTelefone,
  chamaAlterarDependente,
}) => {
  return (
    <>
      <div className="card-dependente card bg-superficie elev1">
        <div>
          <h6>CPF</h6>
          <p className="pequeno">{item.cpfFormatado}</p>
        </div>
        <div className="info-editar">
          <div>
            <h6>Nome</h6>
            <p className="pequeno">{item.nome}</p>
          </div>

          <button
            className="btn-txt so-icone"
            title="Editar dados"
            onClick={() => chamaAlterarDependente(item)}
          >
            <i className="ic-editar"></i>
          </button>
        </div>

        {item.usuarioExternoPF.tipoEstrangeiro != 'N' && (
          <>
            <div>
              <h6>Identidade ou passaporte</h6>
              <p className="pequeno">{item.usuarioExternoPF.cie}</p>
            </div>
          </>
        )}

        <hr />

        <div className="info-editar">
          <div>
            <h6>Email</h6>
            <p className="pequeno email">{item.email}</p>
          </div>

          <button
            className="btn-txt so-icone"
            title="Editar e-mail"
            onClick={() => abreModalEmail(item)}
          >
            <i className="ic-editar"></i>
          </button>
        </div>

        <hr />

        <div className="info-editar">
          <div>
            <h6>Telefone</h6>
            <p className="pequeno">
              {item.usuarioExternoPF.tipoEstrangeiro != 'N' && (
                <>({item.ddiMovel})</>
              )}
              ({item.dddMovel})
              {item.usuarioExternoPF.tipoEstrangeiro === 'N' ? (
                <>{item.foneMovel.replace(/(\d{5})(\d{4})/, '$1-$2')}</>
              ) : (
                <>{item.foneMovel}</>
              )}
            </p>
          </div>

          <button
            className="btn-txt so-icone"
            title="Editar telefone"
            onClick={() => abreModalTelefone(item)}
          >
            <i className="ic-editar"></i>
          </button>
        </div>

        <div className="btns-container">
          <button className="btn-txt" onClick={() => abreModalSenha(item)}>
            <i className="ic-cadeado"></i>
            Alterar senha
          </button>

          <button className="btn-txt" onClick={() => abreModalExcluir(item)}>
            <i className="ic-lixo"></i>
            Excluir
          </button>
        </div>
      </div>
    </>
  );
};

export default CardDependente;
